import { Component, Input, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { HxOrganizationService, HxStorageInvoiceService, HxUiLabelPipe, OrganizationModel, PaymentType, StorageInvoicePaymentRequest } from 'hx-services';
import { HcToastrService } from '@manager-app/service/toastr.service';
import { NgFor } from '@angular/common';
import { NgOptionComponent, NgSelectComponent } from '@ng-select/ng-select';
import { FormsModule } from '@angular/forms';
import { TranslocoPipe } from '@jsverse/transloco';

interface OrganizationPaymentModel extends OrganizationModel {
  paymentType?: PaymentType;
}

@Component({
    selector: 'app-storage-invoices-pay-modal',
    template: `
    <div class="modal-header">
      <h3 class="modal-title">{{ 'storage-invoice-pay.typePaid' | transloco }}</h3>
    </div>
    <div class="modal-body">
      <div class="m--margin-bottom-10"  *ngFor="let organization of organizations">
        <label>
          {{ organization.title | uiLabel }}
        </label>
        <ng-select [(ngModel)]="organization.paymentType">
          <ng-option *ngFor="let type of organization.invoicePaymentTypes" [value]="type">{{'hx.enum.PaymentType.' + type | transloco}}</ng-option>
        </ng-select>
      </div>
    </div>

    <div class="modal-footer">
      <button type="button" class="btn btn-success m--margin-right-10" (click)="paid()">{{ 'storage-invoice-pay.btn.pay' | transloco }}</button>

      <button type="button" class="btn btn-secondary" (click)="modalInstance.dismiss()">{{ 'storage-invoice-pay.btn.close' | transloco }}</button>
    </div>
  `,
    imports: [NgFor, NgSelectComponent, FormsModule, NgOptionComponent, TranslocoPipe, HxUiLabelPipe]
})

export class StorageInvoicePayModal implements OnInit {

  @Input() invoiceIds: number[] = [];
  @Input() storeIds!: number[];
  isLoading = {
    paid: false,
  };
  selectedPaymentTypeByOrg: {organizationId: number, paymentType: PaymentType}[] = [];
  invoicePaymentTypes: PaymentType[] = [];
  organizations: OrganizationPaymentModel[] = [];
  isPaymentTypeEmpty = false;

    constructor(
    public modalInstance: NgbActiveModal,
    private storageInvoiceService: HxStorageInvoiceService,
    private toastr: HcToastrService,
    private orgService: HxOrganizationService,
  ) {
  }

  ngOnInit(): void {
    this.orgService.getOrganizations({ limit: 1000, storeIds: this.storeIds})
      .then(({list, count}) => this.organizations = list.map(org => org.organization));
  }

  paid() {
    this.selectedPaymentTypeByOrg = [];
    this.isPaymentTypeEmpty = false;
    this.organizations.forEach(org => {
      if (!org.paymentType) {
        this.isPaymentTypeEmpty = true;
      }
      this.selectedPaymentTypeByOrg.push({organizationId: org.id, paymentType: org.paymentType});
    });
    if (this.isPaymentTypeEmpty) {
      this.toastr.error('invoicePaymentType.empty');
    } else {
      this.isLoading.paid = true;
      const obj: StorageInvoicePaymentRequest = {invoiceIds: this.invoiceIds, paymentTypes: this.selectedPaymentTypeByOrg};
      this.storageInvoiceService.paidInvoice(obj).subscribe(() => {
        this.isLoading.paid = false;
        this.toastr.success('storage.invoice.paid.success');
        this.modalInstance.close();
      }, () => {
        this.toastr.error('unexpected');
        this.isLoading.paid = false;
        this.modalInstance.dismiss();
      });
    }
  }
}
